webpackJsonp([145692147492288],{

/***/ 903:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"ru":{"title":"Фэйк Авиабилеты"}}}},"pathContext":{"slug":"/ru/terms/","langKey":"ru"}}

/***/ })

});


// WEBPACK FOOTER //
// path---ru-terms-407114886311bd1c54d6.js